import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot
} from '@angular/router';
import { Store } from '@ngxs/store';

import { PageConstant } from 'src/app/constants';
import {
  UnlockTakeoutTicket,
  UpdateTakeoutDeliveryFlag
} from 'src/app/store/takeout-delivery/takeout-delivery.action';
import { TICKETS_STATE_TOKEN } from 'src/app/store/tickets/tickets.state';

@Injectable({
  providedIn: 'root'
})
export class LeaveTakeoutDeliveryGuard implements CanDeactivate<boolean> {
  constructor(private readonly store: Store) {}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ) {
    const isNextPaymentPage = nextState.url.includes(
      PageConstant.PAYMENTS_PAGE
    );
    const isInProgressTicket = currentState.url.includes('new');

    if (!isNextPaymentPage && !isInProgressTicket) {
      const actions: any[] = [new UpdateTakeoutDeliveryFlag(false)];
      const { selectedTicket, tickets } =
        this.store.selectSnapshot(TICKETS_STATE_TOKEN);
      const selectedTicketId = selectedTicket.data;
      const ticket = tickets.byId[selectedTicketId];

      if (ticket?.locked && ticket.takeout_order_status) {
        actions.push(new UnlockTakeoutTicket(selectedTicketId));
      }

      this.store.dispatch(actions);
    }

    return true;
  }
}
